import * as React from 'react';
import { createContext, useContext } from 'react';

type NavAiSparkleContextType = {
  showNavAiSparkle: boolean;
};

const NavAiSparkleContext = createContext<NavAiSparkleContextType>({
  showNavAiSparkle: false,
});

export const useNavAiSparkle = () => {
  return useContext(NavAiSparkleContext);
};

const NavAiSparkleProvider = ({ children }: React.PropsWithChildren) => {
  return <NavAiSparkleContext.Provider value={{ showNavAiSparkle: true }}>{children}</NavAiSparkleContext.Provider>;
};

export default NavAiSparkleProvider;
